export default "__VITE_ASSET__CWHsCwV3__"